'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paymentProviders = require('./paymentProviders');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_paymentProviders).default;
  }
});

var _model = require('./model');

Object.defineProperty(exports, 'PaymentProviderRecordType', {
  enumerable: true,
  get: function get() {
    return _model.PaymentProviderRecordType;
  }
});
Object.defineProperty(exports, 'PaymentProviderListType', {
  enumerable: true,
  get: function get() {
    return _model.PaymentProviderListType;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/payment-providers/index.js
// module id = 450
// module chunks = 0